module.exports = __webpack_public_path__ + "img/lr1-mc-n1.9809725c.gif";